import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/components/ui/page-header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Boxes, AlarmClock, ShieldAlert, Siren, Search, ScrollText, Hash } from "lucide-react";

export const Route = createFileRoute("/_authenticated/app/compliance/")({ component: ComplianceHub });

const TILES = [
  { to: "/app/inventory/lots", icon: Boxes, title: "Lots", desc: "Lot-level inventory with mfg/expiry and origin." },
  { to: "/app/inventory/expiring", icon: AlarmClock, title: "Expiring", desc: "Lots approaching expiry — quarantine in one click." },
  { to: "/app/inventory/holds", icon: ShieldAlert, title: "Quarantine", desc: "On-hold and awaiting-QC balances." },
  { to: "/app/inventory/serials", icon: Hash, title: "Serials", desc: "Tracked unit-level inventory." },
  { to: "/app/compliance/recalls", icon: Siren, title: "Recalls", desc: "Initiate recalls and track downstream notifications." },
  { to: "/app/compliance/trace", icon: Search, title: "Chain of custody", desc: "Look up a serial or lot to see every touch." },
  { to: "/app/admin/audit", icon: ScrollText, title: "Audit log", desc: "All system writes, who and when." },
] as const;

function ComplianceHub() {
  return (
    <>
      <PageHeader title="Compliance & Traceability" description="Lots, expiry, quarantine, serials, recalls, chain of custody, and audit." />
      <div className="px-4 sm:px-6 py-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to}>
            <Card className="hover:bg-accent/40 transition-colors">
              <CardHeader className="flex flex-row items-center gap-3 pb-2">
                <t.icon className="h-5 w-5 text-primary" />
                <CardTitle className="text-base">{t.title}</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">{t.desc}</CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </>
  );
}